import React from "react";
import {PageHero} from "../common/PageHero";

export const Senior = () => {
    return (
        <>
            <PageHero title={'Senioren'}
                      badge={'55+'}
                      lead={'Gezelligheid, recreatie en aangepast trainen voor 55+'}
                      image={'/tafeltennis.jpg'}
                      imageAlt={'Senioren aan de tafel'}/>
            <div className={'ttc-section ttc-split'}>
                <article className={'ttc-card featured'}>
                    <p className={'ttc-eyebrow'}>Elke donderdagmiddag</p>
                    <p className={'ttc-card-body'}>Onze club is er voor jong en oud. Elke donderdagmiddag, heel het jaar
                        door, vanaf 14u tot …, komen onze senior-recreanten samen om iets te drinken en een balletje te
                        slaan op onze club. Deze speelmiddag is een recreatieve middag waarbij gezelligheid en
                        spelplezier centraal staan.</p>
                    <p className={'ttc-card-body'}>Daarnaast biedt de club voor elke senior-recreant ook de mogelijkheid
                        om training te volgen met oefeningen aangepast aan niveau. Neem contact op met onze trainers als
                        je graag eens wil meetrainen.</p>
                    <div className={'ttc-btn-row'}>
                        <a className={'ttc-btn'} href={'/contact'}>Contact</a>
                        <a className={'ttc-btn ghost'} href={'/documents'}>Praktisch</a>
                    </div>
                </article>
                <article className={'ttc-card ttc-card-photo'}>
                    <img src={'/board.jpg'} alt={'Clubfoto'}/>
                </article>
            </div>
        </>
    )
}
